import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import DropoffTimetable from './DropoffTimetable'
import DropoffInformations from './DropoffInformations'

export default class DropoffSelected extends React.Component {

  render() {
    return (
      <div className="dropoff-selected">
        { this.props.modal ?
            <div className="col-12">
              <h2>{I18n.t('shipbacks.modes.dropoffs.chosen.title')}</h2>
            </div>
            : null
        }
        <div className="chosen col-12">
          <div className="row dropoff-point">
            <DropoffInformations dropoff={this.props.dropoff} index={this.props.dropoffIndex} />
            <DropoffTimetable timetable={this.props.dropoff.opening} />
          </div>
        </div>
      </div>
    )
  }
}

DropoffSelected.propTypes = {
  dropoff: PropTypes.object,
  dropoffIndex: PropTypes.number,
  modal: PropTypes.bool,
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/DropoffSelected.jsx